/**
 * @fileoverview POST handler for the "/apps/catalogs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCacheKeys } from "./constants";
import type { PostAppsCatalogsProps, AppsCatalog } from "./types";

export const postAppsCatalogs = reactQueryMutationAdapter(
  appsCatalogsCacheKeys,
  (props: PostAppsCatalogsProps): Promise<AppsCatalog> => {
    return fetch("/apps/catalogs", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
